import {useTranslation} from "react-i18next";

const EnhancesPatrimony = () => {

    const {t} = useTranslation();

    return (
        <>
            <div>
                <h4>{t("serviceDetailPage.valorizza-patrimonio.contentTitle1")}</h4>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText1") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText2") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText3") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText4") as string}}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.valorizza-patrimonio.contentTitle2")}</h4>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText5") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText6") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText7") as string}}></p>
                <ul>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem1")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem2")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem3")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem4")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem5")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem6")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem7")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem8")}</li>
                    <li>{t("serviceDetailPage.valorizza-patrimonio.listitem9")}</li>
                </ul>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText8") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText9") as string}}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.valorizza-patrimonio.contentTitle3")}</h4>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText10") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText11") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText12") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText13") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText14") as string}}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.valorizza-patrimonio.contentTitle4")}</h4>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText15") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText16") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText17") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText18") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.valorizza-patrimonio.contentText19") as string}}></p>
            </div>
        </>
    )
}

export default EnhancesPatrimony;